import type { ChatVectorIndexOption } from "src/db";

export interface UserDatasourceDetail {
    id: string;
    name: string;
    description: string;
    ingestion_status: string;
}

export type TabResolution =
    | { status: "valid"; index: string }
    | {
          status: "no-access";
          index: string;
          datasourceId: string;
          datasourceName: string;
          datasourceDescription: string;
          datasourceIngestionStatus: string;
      }
    | { status: "not-found"; index: string }
    | undefined;

const resolveDefault = ({
    indices,
    storedIndex,
}: {
    indices: ChatVectorIndexOption[];
    storedIndex: string | null;
}): string | undefined => indices.find((option) => option.id === storedIndex)?.id ?? indices[0]?.id;

export const resolveDatasourceTab = ({
    tab,
    available,
    all,
    userDatasources,
    storedIndex,
}: {
    tab: string | undefined;
    available: ChatVectorIndexOption[];
    all: ChatVectorIndexOption[];
    userDatasources: UserDatasourceDetail[];
    storedIndex: string | null;
}): TabResolution => {
    const indices = available.length > 0 ? available : all;
    const fallback = resolveDefault({ indices, storedIndex });

    if (!tab) return fallback ? { status: "valid", index: fallback } : undefined;

    const datasourceId = tab.split("/")[0];
    const match =
        indices.find((option) => option.id === tab) ??
        indices.find((option) => option.datasource_id === tab) ??
        indices.find((option) => option.datasource_id === datasourceId);

    if (match) return { status: "valid", index: match.id };
    if (!fallback) return undefined;

    const known = userDatasources.find((option) => option.id === tab || option.id === datasourceId);
    if (!known) return { status: "not-found", index: fallback };

    return {
        status: "no-access",
        index: fallback,
        datasourceId: known.id,
        datasourceName: known.name,
        datasourceDescription: known.description,
        datasourceIngestionStatus: known.ingestion_status,
    };
};
